import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parsePrice'
})
export class ParsePricePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value) {
      return value.significand * Math.pow(10, value.exponent);
    }
    return null;
  }

}
